import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import classNames from "classnames";
import Item from "./components/Item";
import { GridVariants } from "./GridTypes";

var Grid = function Grid(_ref) {
  var _classNames;

  var children = _ref.children,
      flex = _ref.flex,
      gutterBorder = _ref.gutterBorder,
      gutterless = _ref.gutterless,
      gutterlessAtNarrow = _ref.gutterlessAtNarrow,
      gutterVerticalSmall = _ref.gutterVerticalSmall,
      variant = _ref.variant;
  var getClassName = getClassNameFactory(Grid.displayName);
  var cleanVariant = variant.replace(/,/g, "");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames((_classNames = {}, _defineProperty(_classNames, cleanVariant, true), _defineProperty(_classNames, "flex", flex), _defineProperty(_classNames, "gutterBorder", gutterBorder), _defineProperty(_classNames, "gutterless", gutterless), _defineProperty(_classNames, "gutterlessAtNarrow", gutterlessAtNarrow), _defineProperty(_classNames, "gutterVerticalSmall", gutterVerticalSmall), _classNames))
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

Grid.displayName = "Grid";
Grid.defaultProps = {
  flex: false,
  gutterBorder: false,
  gutterVerticalSmall: false,
  gutterless: false,
  gutterlessAtNarrow: false
};
Grid.Item = Item;
Grid.variants = GridVariants;
export default Grid;